import { render, staticRenderFns } from "./BryntumTabPanel.vue?vue&type=template&id=f1a7c762"
import script from "./BryntumTabPanel.vue?vue&type=script&lang=js"
export * from "./BryntumTabPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports